import { createContext, useCallback, useEffect, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});

  useEffect(() => {
    setAuth({
      refreshToken: localStorage.getItem("refreshToken"),
      accessToken: localStorage.getItem("accessToken"),
      userId: localStorage.getItem("userId"),
      keepMeloggedIn: localStorage.getItem("keepMeLoggedIn"),
      appId: localStorage.getItem("appId"),
    });
  }, []);

  const getUserAuth = useCallback(() => {
    return {
      accessToken: localStorage.getItem("accessToken"),
      refreshToken: localStorage.getItem("refreshToken"),
      userId: localStorage.getItem("userId"),
      keepMeloggedIn: localStorage.getItem("keepMeLoggedIn"),
      appId: localStorage.getItem("appId"),
    };
  }, []);

  const removeUserAuth = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("appId");
    localStorage.removeItem("languageId");
    localStorage.setItem("keepMeLoggedIn", false);
    localStorage.removeItem("userName");
    localStorage.removeItem("userPic");


    setAuth({});
  };

  const createUserAuth = (accessToken, refreshToken, userId, appId) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("userId", userId);
    localStorage.setItem("appId", appId);
  };

  return (
    <AuthContext.Provider
      value={{ auth, createUserAuth, removeUserAuth, getUserAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;
// export const useAuth = () => useContext(AuthContext);
